// extracted by mini-css-extract-plugin
export default {"loadingRing":"loadingRing_RJI3","loading-ring":"loading-ring_FB5o"};